<script setup>
import { useToPlayStore } from "@stores/to-play";
import { useCasinoGamesStore } from "@stores/casino-games";
import { useScrollLock } from "@vueuse/core";

const toPlayStore = useToPlayStore();
const casinoGamesStore = useCasinoGamesStore();
const gamesElementRef = ref(null);

const isGamesElementLocked = useScrollLock(gamesElementRef);

function toggleGame() {
  toPlayStore.toggleGameModal();
  toPlayStore.toggleMenu();
}

function handleSearchState(searchState) {
  isGamesElementLocked.value = searchState;
}

onBeforeMount(() => {
  casinoGamesStore.getSlots();
});
</script>

<template>
  <aside
    class="fixed left-0 flex-col top-0 z-[850] flex h-dvh w-full -translate-x-[100vw] overflow-y-auto bg-brand-sidebar overflow-hidden transition-all duration-300 ease-in-out"
    :class="{ 'translate-x-0': toPlayStore.state.isMenuOpen }"
  >
    <div class="sticky top-0 flex flex-col gap-4 bg-brand-sidebar z-50 pb-4 shadow-2xl">
      <header
        class="flex items-center justify-between border-b border-b-brand-separator p-2 "
      >
        <div class="flex gap-1">
          <NuxtLink to="/">
            <BaseButton
              size="xs"
              class="h-fit gap-2 justify-self-start text-xs leading-none text-gray-400"
            >
              <Icon name="fa6-solid:house" size="18" />
              Home
            </BaseButton>
          </NuxtLink>

          <BaseButton
            size="xs"
            class="h-fit gap-2 justify-self-start text-xs leading-none text-gray-400"
            @click="toggleGame()"
          >
            <Icon size="18" name="fa6-solid:arrow-right-from-bracket" />
            Sair do jogo
          </BaseButton>
        </div>
        <BaseButton
          size="xs"
          class="h-fit gap-2 justify-self-start text-xs leading-none text-gray-400"
          @click="toPlayStore.toggleMenu()"
        >
          <Icon name="fa6-solid:circle-xmark" size="18" />
        </BaseButton>
      </header>
      <div class="px-4">
        <Search @isSearching="handleSearchState" />
      </div>
    </div>

    <section ref="gamesElementRef" class="flex flex-col gap-4 p-4">
      <PlayPopularGames />
    </section>
  </aside>
</template>
